export { DID } from './did.js';
export { anchor, generateKeyPair, resolve, sign, verify } from './utils.js';